import { useEffect, useState } from "react";
import ModalBootstrap from "../../../componentes/modal/ModalBootstrap";
import Decimal from "decimal.js";

const DescuentoModal = ({
    isOpen,
    item,
    onClose,
    onApply,
}) => {
    const [descuentoMonto, setDescuentoMonto] = useState(0);
    const [precio, setPrecio] = useState(item?.precioConImpuesto || 0);
    const [precioOriginal, setPrecioOriginal] = useState(item?.precioConImpuesto || 0);

    useEffect(() => {
        setPrecio(item?.precioConImpuesto || 0);
        setDescuentoMonto(0);
    }, [item]);

    const handleAplicar = () => {
        let precioConImpuestoFinal = new Decimal(precio).minus(descuentoMonto);
        if (precioConImpuestoFinal.isNegative()) precioConImpuestoFinal = new Decimal(0);

        const isvPorcentaje = item.impuesto === "15%"
            ? new Decimal(0.15)
            : item.impuesto === "18%"
                ? new Decimal(0.18)
                : new Decimal(0);

        let precioFinalSinImpuesto = new Decimal(0);
        let isvCalculado = new Decimal(0);

        if (isvPorcentaje.gt(0)) {
            // precio unitario sin impuesto
            precioFinalSinImpuesto = precioConImpuestoFinal
                .mul(item.cantidad)
                .div(new Decimal(1).plus(isvPorcentaje))
                .div(item.cantidad);

            // impuesto calculado
            isvCalculado = precioConImpuestoFinal.minus(precioFinalSinImpuesto);
        } else {
            precioFinalSinImpuesto = precioConImpuestoFinal;
            isvCalculado = new Decimal(0);
        }

        const descuentoAplicadoItem = new Decimal(descuentoMonto);

        onApply({
            ...item,
            precioConImpuesto: precioConImpuestoFinal,
            precioSinImpuesto: precioFinalSinImpuesto,
            isvSinImpuesto: isvCalculado,
            descuentoAplicado: descuentoAplicadoItem,
        });
        onClose();
    };

    return (
        <ModalBootstrap
            titulo={`Descuento para ${item?.descripcion || ""}`}
            modalIsOpen={isOpen}
            setModalIsOpen={onClose}
            mostrarBoton={false}
            pie={
                <button className="btn btn-primary" onClick={handleAplicar}>
                    Aplicar Descuento
                </button>
            }
        >
            <div className="mb-3">
                <label className="form-label fw-bold">Nuevo Precio (L)</label>
                <input
                    type="number"
                    className="form-control"
                    min="0"
                    value={precio}
                    onChange={(e) => setPrecio(parseFloat(e.target.value) || 0)}
                />
            </div>
            <div className="mb-3">
                <label className="form-label fw-bold">Descuento Especial (L)</label>
                <input
                    type="number"
                    className="form-control"
                    min="0"
                    value={descuentoMonto}
                    onChange={(e) => setDescuentoMonto(parseFloat(e.target.value) || 0)}
                />
            </div>
        </ModalBootstrap>
    );
};

export default DescuentoModal;